import { render, staticRenderFns } from "./fourUsersIcon.vue?vue&type=template&id=01621c0d&"
import script from "./fourUsersIcon.vue?vue&type=script&lang=js&"
export * from "./fourUsersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports